import React from 'react';
import profileInfo from "../assets/images/profile-info.png";

const CallSection = () => {
    return (
        <section id="call-action" class="pb-120">
            <div class="overlay">
                <div class="container wow fadeInUp">
                    <div class="row d-flex justify-content-between align-items-center">
                        <div class="col-lg-6 col-md-6">
                            <div class="left-area">
                                <h2 class="title">Build Your Esports Profile</h2>
                                <p>Showcase your achievements, match history and win rate while you build your reputation on Begam.</p>
                                <a href="registration.html" class="cmn-btn-second">Sign Up Free</a>
                            </div>
                        </div>
                        <div class="col-lg-5 col-md-6">
                            <div class="right-area">
                                <img src={profileInfo} alt="image" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default CallSection;